/**
 * Substantivos: the noun with its article, type what it means.
 *
 * The mirror of Nouns, and literally the same component — the only difference
 * is the data. `TypeTranslationCardFront` already accepts a translation in any
 * of the card's languages, so German or English both count without this app
 * knowing either exists.
 */
import { GenderedTranslationFront } from '@/components/practice/GenderedNounCard';

import type { CardFrontProps } from '../types';
import type { SubstantivoPayload } from '../generos/types';

export function CardFront({ card, onAnswer }: CardFrontProps<SubstantivoPayload>) {
  return <GenderedTranslationFront card={card} onAnswer={onAnswer} />;
}
